export default "__VITE_ASSET__p34OEj3z__"